import styled from '@emotion/styled';

const Masterplan = styled('img')({
  width: '100%',
  maxHeight: 375,
  objectFit: 'cover',
  cursor: 'zoom-in'
});

export default Masterplan;
